import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Dayjs } from 'dayjs';
import { map, Observable } from 'rxjs';
import {
  ActivitiesResponseDTO,
  ActivitiyResponseDTO,
  Activity,
  ActivityTypeEnum,
} from '../components/organisms/activities/activities.types';
import { ApiRoutes } from '../constants/api-routes.constants';
import { createEndpointUrl } from '../utilities/pure-functions';

@Injectable({ providedIn: 'root' })
export class ActivityService {
  private readonly http = inject(HttpClient);

  public fetchActivitiesInRange(
    start: Dayjs,
    end: Dayjs,
    pageSize: number,
    pageIndex: number
  ): Observable<ActivitiesResponseDTO> {
    const url = createEndpointUrl(ApiRoutes.activities);
    const params = new HttpParams()
      .append('start', start.format('YYYY-MM-DD'))
      .append('end', end.format('YYYY-MM-DD'))
      .append('pageIndex', pageIndex)
      .append('pageSize', pageSize);

    return this.http.get<ActivitiesResponseDTO>(url, {
      params,
      headers: { addAuthHeader: 'true' },
    });
  }

  public getActivityById(id: string): Observable<Activity> {
    const url = createEndpointUrl(ApiRoutes.activitiesById, { id });

    return this.http
      .get<ActivitiyResponseDTO>(url, { headers: { addAuthHeader: 'true' } })
      .pipe(map((item) => item.payload));
  }

  public createActivity(
    type: ActivityTypeEnum,
    title: string,
    description: string,
    date: Dayjs,
    time: string | null
  ): Observable<Activity> {
    const url = createEndpointUrl(ApiRoutes.activities);
    const body = {
      type,
      title,
      description,
      scheduledDate: date.format('YYYY-MM-DD'),
      scheduledTime: time,
    };

    return this.http
      .post<ActivitiyResponseDTO>(url, body, { headers: { addAuthHeader: 'true' } })
      .pipe(map((item) => item.payload));
  }

  public updateActivity(
    id: string,
    type: ActivityTypeEnum,
    title: string,
    description: string,
    date: Dayjs,
    time: string | null
  ): Observable<Activity> {
    const url = createEndpointUrl(ApiRoutes.activitiesById, { id });
    const body = {
      type,
      title,
      description,
      scheduledDate: date.format('YYYY-MM-DD'),
      scheduledTime: time,
    };

    return this.http
      .patch<ActivitiyResponseDTO>(url, body, { headers: { addAuthHeader: 'true' } })
      .pipe(map((item) => item.payload));
  }

  public delteActivity(id: string): Observable<void> {
    const url = createEndpointUrl(ApiRoutes.activitiesById, { id });

    return this.http.delete<void>(url, { headers: { addAuthHeader: 'true' } });
  }
}
